import React, { ReactElement } from 'react';
import logoSquareWhiteIcon from '@/assets/icons/front/logo-square-white.svg';
import Image from 'next/image';
import { track } from '@/shared/services/analytics/track';

type Props = {};

const Footer : React.FC<Props> = () : ReactElement => {
    const currentYear = new Date().getFullYear();

    const sendConversion = () => {
        track('phone_click', { location: 'footer' });
    };

    return (
        <footer id='contact' className='bg-[#14274D] text-white pt-20 pb-10'>
            <div className='wrapper'>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-10 gap-12 lg:gap-8 mb-16'>
                    {/* Logo Column */}
                    <div className='lg:col-span-2'>
                        <Image
                            className='w-[100px] h-auto'
                            src={logoSquareWhiteIcon}
                            alt='BUBO trans logo'
                        />
                    </div>

                    {/* Brand/Description Column */}
                    <div className='lg:col-span-2 flex flex-col items-start'>
                        <div className='flex flex-col gap-2 text-base text-blue-100/80'>
                            <h3 className='text-xl font-bold text-white'>BUBO trans s.r.o.</h3>
                            <p>Větrná 1041, Beroun-Závodí</p>
                            <p className='mb-4'>266 01, Beroun</p>
                            <p>IČ: 06628842</p>
                            <p>DIČ: CZ06628842</p>
                        </div>
                    </div>

                    {/* Quick Destinations Column */}
                    <div className='lg:col-span-2 flex flex-col gap-6'>
                        <h3 className='text-xl font-bold text-white'>Kam přepravujeme</h3>
                        <div className='flex flex-col gap-3'>
                            {[
                                { name: 'Balík do Německa', link: '/kam-prepravujeme/nemecko' },
                                { name: 'Balík do Francie', link: '/kam-prepravujeme/francie' },
                                { name: 'Balík do Itálie', link: '/kam-prepravujeme/italie' },
                                { name: 'Balík do Polska', link: '/kam-prepravujeme/polsko' },
                                { name: 'Balík na Slovensko', link: '/kam-prepravujeme/slovensko' },
                                { name: 'Balík do USA', link: '/kam-prepravujeme/usa' },
                                { name: 'Balík do Anglie', link: '/kam-prepravujeme/anglie' },
                            ].map((item, index) => (
                                <a
                                    key={index}
                                    href={item.link}
                                    className='text-blue-100/70 hover:text-white transition-colors text-base hover:underline underline-offset-4 w-fit'
                                >
                                    {item.name}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Useful Info Column */}
                    <div className='lg:col-span-2 flex flex-col gap-6'>
                        <h3 className='text-xl font-bold text-white'>Informace</h3>
                        <div className='flex flex-col gap-3'>
                            {[
                                { name: 'Poptávkový formulář', link: '/poptavka' },
                                { name: 'Slovník pojmů', link: '/slovnik-prepravnich-pojmu' },
                                { name: 'Palivové příplatky', link: '/palivovy-priplatek' },
                                { name: 'Přepravní manuál', link: '/prepravni-pruvodce/baleni-dokumentu' },
                                { name: 'Ke stažení', link: '/dokumenty-ke-stazeni' },
                                { name: 'Obchodní podmínky', link: '/obchodni-podminky' },
                                { name: 'Ochrana údajů', link: '/ochrana-osobnich-udaju' },
                            ].map((item, index) => (
                                <a
                                    key={index}
                                    href={item.link}
                                    className='text-blue-100/70 hover:text-white transition-colors text-base hover:underline underline-offset-4 w-fit'
                                >
                                    {item.name}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Contact Column */}
                    <div className='lg:col-span-2 flex flex-col gap-6'>
                        <h3 className='text-xl font-bold text-white'>Kontakt</h3>
                        <div className='flex flex-col gap-6'>
                            <div className='flex flex-col gap-2'>
                                <p className='text-base font-bold text-gray-400 uppercase tracking-wider'>Email</p>
                                <a
                                    href='mailto:obchod@bubotrans.cz'
                                    className='text-white hover:underline underline-offset-2 transition-colors font-bold text-xl w-fit'
                                >
                                    obchod@bubotrans.cz
                                </a>
                            </div>
                            <div className='flex flex-col gap-2'>
                                <p className='text-base font-bold text-gray-400 uppercase tracking-wider'>Telefon</p>
                                <a
                                    href='tel:+420 731 345 733'
                                    onClick={sendConversion}
                                    className='text-blue-white hover:underline underline-offset-2 transition-colors font-bold text-xl w-fit'
                                >
                                    +420 731 345 733
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className='pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-blue-100/40'>
                    <p className='text-blue-100/60 font-medium'>© 2017 - {currentYear} BUBO trans s.r.o. Všechna práva vyhrazena.</p>
                    <div className='flex items-center gap-6 font-medium'>
                        <button
                            type='button'
                            data-cc='show-preferencesModal'
                            className='text-blue-100/60 hover:text-white transition-colors font-medium cursor-pointer'
                        >
                            Nastavení cookies
                        </button>
                        <p>Vytvořeno a spravováno <a href='https://shibesoft.dev' target='_blank' className='text-blue-100/80 hover:text-white transition-colors font-bold'>SHIBESOFT ♥</a></p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
